/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/plan" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdPlan } from "./constants";
import type { EmailIpWarmingAppGroupIdPlanResult } from "./types";
import { isEmailIpWarmingAppGroupIdPlanResult } from "./validators";

export const getEmailIpWarmingAppGroupIdPlan = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdPlan,
  // `planId` is an optional trailing path segment, modeled as a string rest arg: the cache-key param
  // type the fetcher adapter infers excludes `undefined`, so a `planId?: string` arg is rejected.
  (signal: AbortSignal, appGroupId: string, ...[planId]: string[]): Promise<EmailIpWarmingAppGroupIdPlanResult> => {
    return fetch(`/email/ip_warming/${appGroupId}/plan${planId ? `/${planId}` : ""}`, "GET", {}, { signal });
  },
  isEmailIpWarmingAppGroupIdPlanResult
);
